import { Link } from "react-router-dom";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { ArrowRight, Bot, Building2, Cpu, Layers } from "lucide-react";

const PILLARS = [
  {
    icon: Layers,
    title: "Robotics-as-a-Service",
    body: "Assessment, deployment, training, fleet management, maintenance, and support delivered as one managed program instead of a purchase order.",
    to: "/raas",
    cta: "Explore RaaS",
  },
  {
    icon: Bot,
    title: "Commercial Robotics",
    body: "Cleaning, delivery, logistics, humanoid, and outdoor grounds platforms selected by the work they do — not by the badge on the chassis.",
    to: "/robots",
    cta: "Browse Robotics",
  },
  {
    icon: Cpu,
    title: "AI Workforce",
    body: "AI receptionists, customer service, appointment setting, lead qualification, and workflow automation running alongside your people.",
    to: "/ai-workforce",
    cta: "See AI Employees",
  },
  {
    icon: Building2,
    title: "Enterprise Deployments",
    body: "Discovery, pilot, validation, and multi-site rollout with documented scope, training, and reporting your procurement team can approve.",
    to: "/enterprise",
    cta: "Enterprise Programs",
  },
];

const AutonomousWorkforceSection = () => (
  <section className="my-12 md:my-16" aria-labelledby="autonomous-workforce-heading">
    <div className="text-center max-w-3xl mx-auto mb-8">
      <span className="inline-block rounded-full border border-primary/30 bg-primary/5 px-3 py-1 text-[10px] sm:text-xs font-semibold tracking-[0.2em] uppercase text-primary mb-4">
        One Company. One Automation Strategy.
      </span>
      <h2
        id="autonomous-workforce-heading"
        className="font-orbitron text-2xl md:text-4xl font-bold mb-3"
      >
        Physical Automation + Digital Automation
      </h2>
      <p className="text-muted-foreground md:text-lg">
        Neil AI connects robots on the floor, machines on the grounds, and AI employees in your
        systems into a single autonomous workforce — assessed, deployed, and managed by one partner.
      </p>
    </div>

    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {PILLARS.map((p) => {
        const Icon = p.icon;
        return (
          <Card
            key={p.title}
            className="glass-effect border-[hsl(var(--line))] p-6 flex flex-col hover:border-primary/40 transition-colors"
          >
            <Icon className="h-6 w-6 text-primary mb-3" />
            <h3 className="font-orbitron font-bold text-lg mb-2">{p.title}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed flex-1">{p.body}</p>
            <Button asChild variant="ghost" className="mt-4 justify-start px-0 font-bold text-primary hover:bg-transparent">
              <Link to={p.to} className="inline-flex items-center gap-1.5">
                {p.cta} <ArrowRight className="h-4 w-4" />
              </Link>
            </Button>
          </Card>
        );
      })}
    </div>
  </section>
);

export default AutonomousWorkforceSection;
